module.exports = __webpack_public_path__ + "images/manifestum/feuTricolore.50934a71.svg";